import { useState } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../../../dashboard/components/dashboard/Sidebar';
import Navbar from '../../../dashboard/components/dashboard/Navbar';
import { Outlet } from 'react-router-dom';
import { selectCurrentPlan } from '../../../../app/store/slices/subscriptionSlice';
import GoogleAd from '../ads/GoogleAd';
import { CanvasProvider } from '../../../dashboard/context/CanvasContext';
import UserCashbotWrapper from '../../../dashboard/components/dashboard/UserCashbotWrapper';

const DashboardLayout = () => {
  const defaultClickUrl = process.env.REACT_APP_DEFAULT_AD_CLICK_URL || 'https://www.mycashcanvas.com';
  const [activeSection, setActiveSection] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const currentPlan = useSelector(selectCurrentPlan);
  const showAds = currentPlan?.plan?.planKey === 'free';
  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

 
  return (
    <CanvasProvider>
    <div className="min-h-screen overflow-hidden bg-gray-50">
      <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <Navbar onToggleSidebar={toggleSidebar} />
      </div>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="pt-[80px]  flex min-h-[calc(100vh-80px)] relative">
        {/* Sidebar Container */}
        <div className={`
          fixed left-0 bottom-0 top-20 mt-8 pr-4 md:bg-transparent
          transform transition-transform duration-300 ease-in-out z-40
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-60'}
          w-[230px] md:w-64
        `}>
          <div className="h-full flex flex-col overflow-hidden">
            {/* Sidebar Navigation with flex-shrink-0 */}
            <div className="flex-1 overflow-y-auto custom-scrollbar">
              <Sidebar 
                activeSection={activeSection}
                onSectionChange={(section) => {
                  handleSectionChange(section);
                  if (window.innerWidth < 768) setIsSidebarOpen(false);
                }}
              />
            </div>

            {/* Ads container with flex constraints */}
            {showAds && (
              <div className="hidden sm:flex flex-col mt-auto mb-4 mx-auto w-[90%] min-h-[280px] rounded-xl overflow-hidden">
                {/* <p className="text-gray-500 text-xs text-center py-1">Advertisement</p> */}
                <div className="relative flex-1 flex items-center justify-center">
                  <GoogleAd
                    slot={process.env.REACT_APP_AD_SLOT_SIDEBAR}
                    format="auto"
                    responsive={true}
                    dataAdtest={process.env.REACT_APP_ENABLE_ADTEST === 'true'}
                    clickUrl={defaultClickUrl}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className={`flex-1 overflow-y-auto ${isSidebarOpen ? 'md:ml-60' : ''} min-h-[calc(100vh-80px)]`}>
          <main className="p-4 bg-gray-50">
            <Outlet context={[activeSection, setActiveSection]} />
            {showAds && (
              <div className="w-[calc(100%-2rem)] min-h-[280px] mt-8 mx-4 rounded-xl overflow-hidden flex items-center justify-center">
                <GoogleAd
                    slot={process.env.REACT_APP_AD_SLOT_MAIN}
                  format="auto"
                  responsive={true}
                    dataAdtest={process.env.REACT_APP_ENABLE_ADTEST === 'true'}
                    clickUrl={defaultClickUrl}
                />
              </div>
            )}
          </main>
        </div>

        <div className="fixed bottom-4 right-4 z-50">
        <UserCashbotWrapper />
        </div>
      </div>
    </div>
    </CanvasProvider>
  );
};

export default DashboardLayout;